import "./MappingSummary.css"

const MappingSummary = ({ mappedData, mappingPaths }) => {
  if (!mappedData || !mappingPaths) {
    return <div className="no-mapping-data">No mapping data available</div>
  }

  const renderMappingSection = (title, fields) => {
    return (
      <div className="mapping-section">
        <h3 className="mapping-section-title">{title}</h3>
        <div className="mapping-grid">
          {fields.map((field) => {
            const fieldKey = field.key || field
            const fieldLabel = field.label || field

            return (
              <div key={fieldKey} className="mapping-item">
                <div className="mapping-field">
                  <span className="mapping-field-label">{fieldLabel}:</span>
                  <span className="mapping-field-value">{mappedData[fieldKey] || "N/A"}</span>
                </div>
                <div className="mapping-path">
                  <span className="mapping-path-label">Source:</span>
                  <span className="mapping-path-value">{mappingPaths[fieldKey] || "Not found"}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className="mapping-summary">
      {renderMappingSection("Demographics", ["AHCno", "Id", "Name", "Age", "Gender"])}

      {renderMappingSection("Physical Measurements", [
        "Height",
        "Weight",
        "BMI",
        "BloodPressureSystolic",
        "BloodPressureDiastolic",
        "HeartRatePerMinute",
        "RespirationRatePerMinute",
        "Rhythm",
      ])}

      {renderMappingSection("Medical Conditions", [
        "DiabetesMellitus",
        "Hypertension",
        "Dyslipidaemia",
        "PrevHeartDisease",
        "HeartRelatedSymptom",
        "FamilyHistoryofHeartDisease",
      ])}

      {renderMappingSection("Lifestyle Factors", ["PhysicalActivity", "Smoke", "Tobacco", "Diet", "Alcohol"])}
    </div>
  )
}

export default MappingSummary

